import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'

import { toaster } from '@/components/Toaster/toaster'
import { connectivityStore } from '@/store/ConnectivityStore'

export const NetworkStatus = observer(
  ({ children }: React.PropsWithChildren) => {
    const { isOnline } = connectivityStore

    useEffect(() => {
      if (!isOnline) {
        toaster.create({
          id: 'offlineNotification',
          type: 'error',
          title:
            'Информация может быть неактуальной, проверьте подключение к интернету',
          duration: 5000,
          closable: true,
        })
      }
    }, [isOnline])

    return <> {children}</>
  },
)
